"use client";
import { ErrorBoundary } from "react-error-boundary";
import { Suspense } from "react";
import { KycDialogError } from "./error";
import { KycDialogLoading } from "./loading";
import { KycDialogContent } from "./content";

export function KycDialog() {
  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <KycDialogError error={error} resetErrorBoundary={resetErrorBoundary} />
      )}
      onError={(error, errorInfo) => {
        console.error("ParcelList Error:", error, errorInfo);
      }}
      onReset={() => {
        console.log("ParcelList error boundary reset");
      }}
    >
      <Suspense fallback={<KycDialogLoading />}>
        <KycDialogContent />
      </Suspense>
    </ErrorBoundary>
  );
}
